import { createContext } from 'react';

const SidebarCollapseContext = createContext(() => { });

export default SidebarCollapseContext;